<template>
<div class="chapter">
<div class="inner_page">
<h1 class="partno"><a id="page_49"><em class="italic">PART II</em></a></h1><a id="page_49">
<h1 class="parttitle"><em class="italic">The Language of the Frontier Myth</em></h1>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Part02.vue?d435dbec